const styles = (theme) => ({
  card: {
    minWidth: 275,
    position: 'absolute',
  },
  button: {
    margin: theme.spacing(1),
    textAlign: 'right',
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
  },
})

export default styles
